"use client";

import * as React from "react";
import { Quote, Terminal, Cpu, Network } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
const testimonials = [{
  quote: "\"B-Tech ha centralizzato i nostri dati aziendali rendendoli accessibili in modo sicuro da qualsiasi dispositivo.\nOggi il lavoro è più organizzato e le informazioni sono sempre disponibili.\"",
  author: "Cliente Aziendale",
  role: "Responsabile Vendite",
  industry: "Settore Automotive"
}, {
  quote: "\"Prima avevamo diversi Wi-Fi negli uffici e ogni volta che ci si spostava da una stanza all’altra bisognava cambiare rete.\nDopo l’intervento di B-Tech la connessione è unica e funziona ovunque negli uffici senza interruzioni.\"",
  author: "Cliente Aziendale",
  role: "Responsabile Operativo",
  industry: "Società di Consulenza"
}, {
  quote: "\"Prima molte operazioni in magazzino venivano fatte con il portatile, che non era molto pratico.\nCon il supporto di B-Tech abbiamo introdotto dei palmari che hanno reso il lavoro molto più veloce e semplice.\nOra stampiamo anche le etichette direttamente in magazzino senza doverle far preparare da terzi.\"",
  author: "Azienda Logistica",
  role: "Responsabile Logistica",
  industry: "Operazioni di\xA0"
}];
export default function FeedbackERisultati() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  return <section id="feedback-e-risultati" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_50%,rgba(6,182,212,0.05),transparent_70%)]" />
        <div className="absolute bottom-0 right-0 w-1/3 h-1/3 bg-primary/5 blur-[100px]" />
        
        {}
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(to right, var(--border) 1px, transparent 1px), linear-gradient(to bottom, var(--border) 1px, transparent 1px)`,
        backgroundSize: '40px 40px'
      }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-mono mb-6 uppercase tracking-wider">
            <Terminal className="w-3 h-3" />
            <span>Feedback Clienti</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-foreground">Nostre Soluzioni</h2>
          <p className="text-muted-foreground text-lg">Esperienze reali dall’utilizzo delle tecnologie<div>negli ambienti di lavoro aziendali.</div></p>
        </div>

        <div className="max-w-5xl mx-auto">
          <Carousel setApi={setApi} className="w-full">
            <CarouselContent>
              {testimonials.map((item, index) => <CarouselItem key={index} data-index={index}>
                  <div className="p-6 md:p-12">
                    <div className="relative bg-card/30 backdrop-blur-sm border border-border/50 rounded-sm p-8 md:p-16 overflow-hidden group hover:border-primary/30 transition-colors duration-500">
                      {}
                      <div className="absolute top-0 left-0 w-2 h-8 bg-primary/50" />
                      <div className="absolute top-0 left-0 w-8 h-2 bg-primary/50" />
                      <div className="absolute bottom-0 right-0 w-2 h-8 bg-primary/50" />
                      <div className="absolute bottom-0 right-0 w-8 h-2 bg-primary/50" />
                      
                      {}
                      <div className="absolute -right-10 -bottom-10 text-primary/5 transform rotate-12 group-hover:scale-110 transition-transform duration-700">
                        {index % 2 === 0 ? <Cpu size={200} /> : <Network size={200} />}
                      </div>

                      <div className="relative z-10 flex flex-col items-center text-center">
                        <Quote className="w-12 h-12 text-primary mb-8 opacity-80" />
                        
                        <blockquote className="text-2xl md:text-3xl font-medium leading-relaxed mb-10 text-foreground/90 font-sans">
                          "{item.quote}"
                        </blockquote>

                        <div className="w-16 h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent mb-8" />

                        <div className="flex flex-col items-center gap-1">
                          <cite className="not-italic font-bold text-lg text-foreground tracking-wide">
                            {item.author}
                          </cite>
                          <div className="flex items-center gap-2 text-sm font-mono text-primary/80">
                            <span>{item.role}</span>
                            <span className="w-1 h-1 rounded-full bg-primary/50" />
                            <span>{item.industry}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="hidden md:block">
              <CarouselPrevious className="left-4 border-primary/20 hover:bg-primary/10 hover:text-primary text-muted-foreground" />
              <CarouselNext className="right-4 border-primary/20 hover:bg-primary/10 hover:text-primary text-muted-foreground" />
            </div>

            {}
            <div className="flex justify-center gap-2 mt-8">
              {Array.from({
              length: count
            }).map((_, i) => <button key={i} data-index={i} className={cn("h-1 transition-all duration-300 rounded-full", current === i + 1 ? "w-12 bg-primary shadow-[0_0_10px_rgba(6,182,212,0.5)]" : "w-6 bg-muted-foreground/20 hover:bg-muted-foreground/40")} onClick={() => api?.scrollTo(i)} aria-label={`Vai alla slide ${i + 1}`} />)}
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}